import React from "react"
import { useForm } from "@hooks/useForm"
import { Box, Button, FormControl, FormLabel, Stack, Text } from "@chakra-ui/react"
import Dropdown from "./Form/Dropdown"

import { FormTextarea } from "./Form/FormTextarea"
import { FormInput } from "./Form/FormInput"

type FormProps = {
  buttonText?: string
  formHandle: string
}
const FormFieldSerializer = ({ field, handleChange, data }: any) => {
  const name = field.title ?? field.placeholder
  const title = name
    ?.toLowerCase()
    ?.replace(/[^a-zA-Z ]/g, "")
    ?.replace(/ /g, "_")
  if (field?._type === "objectFormDropdownOptions") {
    const optionsList = field?.options?.map((option: string) => ({
      label: title,
      value: option,
    }))

    if (!optionsList?.length) return null

    return (
      <FormControl>
        {field?.title && <FormLabel>{field?.title}</FormLabel>}
        <Dropdown name={title} onChange={handleChange} w={"100%"}>
          {optionsList?.map((option: string) => (
            <option key={option.value} value={option.value}>
              {option.value}
            </option>
          ))}
        </Dropdown>
      </FormControl>
    )
  }

  switch (field?.fieldType) {
    case "text":
      return (
        <FormControl>
          <FormLabel>{field.title}</FormLabel>
          <FormInput name={title} value={data[title] ?? ""} onChange={handleChange} placeholder={field.placeholder} />
        </FormControl>
      )
    case "textarea":
      return (
        <FormControl>
          <FormLabel>{field.title}</FormLabel>
          <FormTextarea name={title} value={data[title] ?? ""} onChange={handleChange} placeholder={field.placeholder} />
        </FormControl>
      )

    default:
      return null
  }
}

const Form: React.FC<FormProps> = ({ formHandle, buttonText }) => {
  const { getForm, handleChange, submitForm, data, loading } = useForm()
  const form = getForm(formHandle)
  const [submitMessage, setSubmitMessage] = React.useState(false)

  const handleSubmit = async (event: React.SyntheticEvent) => {
    event.preventDefault()

    const formFieldsArray = []

    for (const field of form.formFields) {
      const title = field.title
      const transformedTitle = title.toUpperCase().replace(/ /g, "_").replace(/[&,*]/g, "")
      formFieldsArray.push(transformedTitle)
    }

    for (const key of formFieldsArray) {
      if (key in data) {
        //
      } else {
        data[`${key}`] = ""
      }
    }

    await submitForm(form, data)
    setSubmitMessage(true)
  }

  // Used to make sure that pressing "enter" doesn't submit the form
  if (typeof document !== "undefined") {
    const formChecker = document?.getElementById("wholeSaleForm")
    formChecker?.addEventListener("keypress", function (e) {
      if (e.key === "Enter" && e.target.tagName !== "TEXTAREA") {
        e.preventDefault()
      }
    })
  }

  return (
    <Box as="form" id="wholeSaleForm" onSubmit={handleSubmit}>
      <Stack spacing={[2, 4]}>
        {form?.formFields?.map((field: any) => (
          <Box key={field?._key}>
            <FormFieldSerializer handleChange={handleChange} field={field} data={data} />
          </Box>
        ))}
        {submitMessage ? (
          <>
            <Text fontSize="18px"> {form.formSuccessMessage} </Text>
          </>
        ) : null}

        {buttonText && (
          <Button type="submit" isDisabled={loading} isLoading={loading} w={["full", 49]} size="lg" variant={"blue"}>
            {buttonText}
          </Button>
        )}
      </Stack>
    </Box>
  )
}

export default React.memo(Form)
